// extracted by mini-css-extract-plugin
export var container = "_dg-0";
export var content = "_dg-3";
export var customerTitle = "_dg-4";
export var empty = "_dg-5";
export var gray = "_dg-6";
export var header = "_dg-7";
export var info = "_dg-8";
export var loading = "_dg-2";
export var loadingCard = "_dg-9";
export var oneLine = "_dg-a";
export var personName = "_dg-e";
export var pillContainer = "_dg-b";
export var selected = "_dg-1";
export var text = "_dg-c";
export var twoLines = "_dg-d";
export var unread = "_dg-f";
export var unreadIndicator = "_dg-g";